import { useMemo } from 'react'
import { StockType } from 'types/stock'
import { CheckoutItemType } from 'types/checkoutItem'
import { sumCheckoutItemsAmount, sumStocksAmount } from 'lib/helper'

const useRemainingStocksAmount = (stocks: StockType[], checkoutItems: CheckoutItemType[]): number => {
  return useMemo(() => {
    // オープン時在庫数から注文数を引く
    return sumStocksAmount(stocks) - sumCheckoutItemsAmount(checkoutItems)
  }, [stocks, checkoutItems])
}

export default useRemainingStocksAmount
